<template>
    <div id="userdetail-page" class="mb-5">
        <b-card>
            <b-row>
              <b-col md="12">
              <h3>{{$route.name}}</h3>
              <b-breadcrumb>
                <b-breadcrumb-item><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item>
                <b-breadcrumb-item><router-link to="/company-structure/employee">Employee</router-link></b-breadcrumb-item>
                <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
              </b-breadcrumb>
              <div class="border-bottom"></div>
             </b-col>
            </b-row>
            <form v-on:submit.prevent="doSubmit" class="mt-3">
              <div>
                <b-tabs v-model="tabIndex" small card>
                  <b-tab title="Management Account" v-if="this.$route.params.id === undefined">
                    <b-row class="mt-1">
                      <b-col md="4">
                        <label class="labels">username *</label>
                        <div class="form-group" v-bind:class="errors.has('username') ? 'has-error':''">
                          <input class="form-control" id="field-type" v-if="this.$route.params.id !== undefined" disabled v-model="model.username" />
                          <input v-else-if="this.$route.params.id === undefined" type="text" class="form-control" v-bind:class="errors.has('username') ? 'is-invalid':''" data-vv-as="username" name="username" v-model="model.username" v-validate="'required'" placeholder="Username" />
                          <p v-if="errors.has('username') !== null"></p>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="4">
                        <label class="labels">email *</label>
                        <div class="form-group" v-bind:class="errors.has('email') ? 'has-error':''">
                          <input type="email" class="form-control" v-bind:class="errors.has('email') ? 'is-invalid':''" data-vv-as="email" name="email" v-model="model.email" v-validate="'required'" placeholder="Ex: myname@example.com" />
                          <p v-if="errors.has('email') !== null"></p>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="4">
                        <label class="labels">password <label style="font-size:10px!important; text-transform:lowercase!important;">(8 characters minimum) </label> *</label>
                        <div class="form-group" v-bind:class="errors.has('password') ? 'has-error':''">
                          <input type="password" minlength="8" class="form-control" v-bind:class="errors.has('password') ? 'is-invalid':''" data-vv-as="password" name="password" v-model="model.password" v-validate="'required'" placeholder="Password" />
                          <p v-if="errors.has('password') !== null"></p>
                        </div>
                      </b-col>
                    </b-row>
                  </b-tab>
                  <b-tab title="Employee Info">
                    <b-row class="mt-1">
                      <b-col md="5">
                        <label class="labels">staff id</label>
                        <div class="form-group" v-bind:class="errors.has('idStaff') ? 'has-error':''">
                          <b-form-input type="text" id="field-type" class="type-customer" readonly v-bind:class="errors.has('idStaff') ? 'is-invalid':''" data-vv-as="idStaff" name="idStaff" v-model="model.idStaff" placeholder="ID Staff" />
                          <p v-if="errors.has('idStaff') !== null"></p>
                        </div>
                      </b-col>
                      <b-col md="2">
                      </b-col>
                      <b-col md="5">
                        <label class="labels">date of birth *</label>
                        <div class="form-group" v-bind:class="errors.has('dob') ? 'has-error':''">
                          <b-form-datepicker type="date" :max="max" class="form-control" v-bind:class="errors.has('dob') ? 'is-invalid':''" data-vv-as="dob" name="dob" v-model="model.dob" v-validate="'required'" placeholder="Date of Birth" />
                          <p v-if="errors.has('dob') !== null"></p>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="5">
                        <label class="labels">first name *</label>
                        <div class="form-group" v-bind:class="errors.has('firstName') ? 'has-error':''">
                          <input type="text" class="form-control" v-bind:class="errors.has('firstName') ? 'is-invalid':''" data-vv-as="firstName" name="firstName" v-model="model.firstName" v-validate="'required'" placeholder="First Name" />
                          <p v-if="errors.has('firstName') !== null"></p>
                        </div>
                      </b-col>
                      <b-col md="2">
                      </b-col>
                      <b-col md="5">
                        <label class="labels">place of birth</label>
                        <div class="form-group" v-bind:class="errors.has('pob') ? 'has-error':''">
                          <input type="text" class="form-control" data-vv-as="pob" name="pob" v-model="model.pob"  placeholder="Place of Birth" />
                          <p v-if="errors.has('pob') !== null"></p>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="5">
                        <label class="labels">last name *</label>
                        <div class="form-group" v-bind:class="errors.has('lastName') ? 'has-error':''">
                          <input type="text" class="form-control" v-bind:class="errors.has('lastName') ? 'is-invalid':''" data-vv-as="lastName" name="lastName" v-model="model.lastName" v-validate="'required'" placeholder="Last Name" />
                          <p v-if="errors.has('lastName') !== null"></p>
                        </div>
                      </b-col>
                      <b-col md="2">
                      </b-col>
                      <b-col md="5">
                        <label class="labels">blood type </label>
                        <div class="form-group" v-bind:class="errors.has('bloodType') ? 'has-error':''">
                          <select v-model="model.bloodType" :error="errors.first('bloodType')" name="bloodType" class="form-control">
                            <option value=null>Please Select Blood Type</option>
                            <option value="A">A</option>
                            <option value="B">B</option>
                            <option value="AB">AB</option>
                            <option value="O">O</option>
                          </select>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="5">
                        <label class="labels">nick name </label>
                        <div class="form-group" v-bind:class="errors.has('nickName') ? 'has-error':''">
                          <input type="text" class="form-control" data-vv-as="nickName" name="nickName" v-model="model.nickName" placeholder="Nick Name" />
                          <p v-if="errors.has('nickName') !== null"></p>
                        </div>
                      </b-col>
                      <b-col md="2">
                      </b-col>
                      <b-col md="5">
                        <label class="labels">gender </label>
                        <div class="form-group" v-bind:class="errors.has('gender') ? 'has-error':''">
                          <select v-model="model.gender" :error="errors.first('gender')" name="gender" class="form-control">
                            <option value=null>Please Select Gender</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                          </select>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="5">
                        <label class="labels">identity number * </label>
                        <div class="form-group" v-bind:class="errors.has('icNumber') ? 'has-error':''">
                          <input type="text" class="form-control" v-bind:class="errors.has('icNumber') ? 'is-invalid':''" v-validate="'required'" name="icNumber" v-model="model.icNumber" placeholder="Identity Number" />
                          <p v-if="errors.has('icNumber') !== null"></p>
                        </div>
                      </b-col>
                      <b-col md="2">
                      </b-col>
                      <b-col md="5">
                        <label class="labels">marital status </label>
                        <div class="form-group" v-bind:class="errors.has('maritalStatus') ? 'has-error':''">
                          <select v-model="model.maritalStatus" :error="errors.first('maritalStatus')" name="maritalStatus" class="form-control">
                            <option value=null>Please Select Marital Status</option>
                            <option value="Single">Single</option>
                            <option value="Married">Married</option>
                            <option value="Divorced">Divorced</option>
                            <option value="Widowed">Widowed</option>
                          </select>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="5">
                        <label class="labels">driver's license </label>
                        <div class="form-group" v-bind:class="errors.has('drivingLicence') ? 'has-error':''">
                          <input type="number" class="form-control" data-vv-as="drivingLicence" name="drivingLicence" v-model="model.drivingLicence" placeholder="Driver's License" />
                          <p v-if="errors.has('drivingLicence') !== null"></p>
                        </div>
                      </b-col>
                    </b-row>
                  </b-tab>
                  <b-tab title="Contact Info">
                    <b-row class="mt-1">
                      <b-col md="1">
                        <label class="labels">phone </label>
                        <div v-if="$store.getters['account/accountData'].account.timezone !== 'Asia/Jakarta'" class="form-group" v-bind:class="errors.has('extPhone') ? 'has-error':''">
                          <input id="extend-phone" readonly class="form-control label-extphone-my" data-vv-as="extPhone" name="extPhone" v-model="model.extPhoneMY" />
                        </div>
                        <div v-else class="form-group" v-bind:class="errors.has('extPhone') ? 'has-error':''">
                          <input id="extend-phone" readonly class="form-control label-extphone-id" data-vv-as="extPhone" name="extPhone" v-model="model.extPhoneID" />
                        </div>
                      </b-col>
                      <b-col md="4">
                        <div class="form-group" v-bind:class="errors.has('phone') ? 'has-error':''">
                          <input type="number" class="form-control label-phone" data-vv-as="phone" name="phone" v-model="model.phone" placeholder="Phone" />
                          <p v-if="errors.has('phone') !== null"></p>
                        </div>
                      </b-col>
                      <b-col md="2">
                      </b-col>
                      <b-col md="5">
                        <label class="labels">work email *</label>
                        <div class="form-group" v-bind:class="errors.has('workemail') ? 'has-error':''">
                          <input type="email" class="form-control" v-bind:class="errors.has('workemail') ? 'is-invalid':''" data-vv-as="workemail" name="workemail" v-model="model.workemail" v-validate="'required'" placeholder="Ex: myname@example.com" />
                          <p v-if="errors.has('workemail') !== null"></p>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="1">
                        <label class="workphone-label">work phone </label>
                        <div v-if="$store.getters['account/accountData'].account.timezone !== 'Asia/Jakarta'" class="form-group" v-bind:class="errors.has('extPhone') ? 'has-error':''">
                          <input id="extend-phone" readonly class="form-control label-extphone-my" data-vv-as="extPhone" name="extPhone" v-model="model.extPhoneMY" />
                        </div>
                        <div v-else class="form-group" v-bind:class="errors.has('extPhone') ? 'has-error':''">
                          <input id="extend-phone" readonly class="form-control label-extphone-id" data-vv-as="extPhone" name="extPhone" v-model="model.extPhoneID" />
                        </div>
                      </b-col>
                      <b-col md="4">
                        <div class="form-group" v-bind:class="errors.has('workphone') ? 'has-error':''">
                          <input type="number" class="form-control label-phone phoness" data-vv-as="workphone" name="workphone" v-model="model.workphone" placeholder="Work Phone" />
                          <p v-if="errors.has('workphone') !== null"></p>
                        </div>
                      </b-col>
                      <b-col md="2">
                      </b-col>
                      <b-col md="5">
                        <label class="labels">address *</label>
                        <div class="form-group" v-bind:class="errors.has('address') ? 'has-error':''">
                          <b-form-textarea type="text" class="form-control" v-bind:class="errors.has('address') ? 'is-invalid':''" data-vv-as="address" name="address" v-model="model.address" v-validate="'required'" placeholder="Address" />
                          <p v-if="errors.has('address') !== null"></p>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <!--<b-col md="5">
                      </b-col>-->
                      <b-col md="7">
                      </b-col>
                      <b-col md="5">
                        <label class="labels">current address </label>
                        <div class="form-group" v-bind:class="errors.has('addressCurrent') ? 'has-error':''">
                          <b-form-textarea type="text" class="form-control" data-vv-as="addressCurrent" name="addressCurrent" v-model="model.addressCurrent" placeholder="Current Address" />
                          <p v-if="errors.has('addressCurrent') !== null"></p>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col class="mt-2">
                        <a href="#" class="text-emergency mt-5">Emergency Contact</a >
                      </b-col>
                      <b-col md="12">
                        <hr class="mt-1">
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="12">
                        <label class="labels">primary contact </label>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="4">
                        <div class="form-group" v-bind:class="errors.has('relationPrimaryName') ? 'has-error':''">
                          <input type="text" class="form-control" data-vv-as="relationPrimaryName" name="relationPrimaryName" v-model="model.relationPrimaryName" placeholder="Name" />
                          <p v-if="errors.has('relationPrimaryName') !== null"></p>
                        </div>
                      </b-col>
                      <b-col md="1">
                        <div v-if="$store.getters['account/accountData'].account.timezone !== 'Asia/Jakarta'" class="form-group" v-bind:class="errors.has('extPhone') ? 'has-error':''">
                          <input id="extend-emergencyPhone" readonly class="form-control label-extphone-my" data-vv-as="extPhone" name="extPhone" v-model="model.extPhoneMY" />
                        </div>
                        <div v-else class="form-group" v-bind:class="errors.has('extPhone') ? 'has-error':''">
                          <input id="extend-emergencyPhone" readonly class="form-control label-extphone-id" data-vv-as="extPhone" name="extPhone" v-model="model.extPhoneID" />
                        </div>
                      </b-col>
                      <b-col md="3">
                        <div class="form-group" v-bind:class="errors.has('relationPrimaryPhone') ? 'has-error':''">
                          <input type="number" class="form-control label-emergencyPhone" data-vv-as="relationPrimaryPhone" name="relationPrimaryPhone" v-model="model.relationPrimaryPhone" placeholder="Phone" />
                          <p v-if="errors.has('relationPrimaryPhone') !== null"></p>
                        </div>
                      </b-col>
                      <b-col md="4">
                        <div class="form-group" v-bind:class="errors.has('relationshipPrimary') ? 'has-error':''">
                          <select v-model="model.relationshipPrimary" :error="errors.first('relationshipPrimary')" name="relationshipPrimary" class="form-control">
                            <option value=null>Please Select Relation</option>
                            <option value="Parent">Parent</option>
                            <option value="Child">Child</option>
                            <option value="Brother">Brother</option>
                            <option value="Sister">Sister</option>
                            <option value="Nephew">Nephew</option>
                            <option value="Niece">Niece</option>
                            <option value="Cousin">Cousin</option>
                          </select>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="12">
                        <label class="labels">secondary contact </label>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="4">
                        <div class="form-group" v-bind:class="errors.has('relationSecondaryName') ? 'has-error':''">
                          <input type="text" class="form-control" data-vv-as="relationSecondaryName" name="relationSecondaryName" v-model="model.relationSecondaryName" placeholder="Name" />
                          <p v-if="errors.has('relationSecondaryName') !== null"></p>
                        </div>
                      </b-col>
                      <b-col md="1">
                        <div v-if="$store.getters['account/accountData'].account.timezone !== 'Asia/Jakarta'" class="form-group" v-bind:class="errors.has('extPhone') ? 'has-error':''">
                          <input id="extend-emergencyPhone" readonly class="form-control label-extphone-my" data-vv-as="extPhone" name="extPhone" v-model="model.extPhoneMY" />
                        </div>
                        <div v-else class="form-group" v-bind:class="errors.has('extPhone') ? 'has-error':''">
                          <input id="extend-emergencyPhone" readonly class="form-control label-extphone-id" data-vv-as="extPhone" name="extPhone" v-model="model.extPhoneID" />
                        </div>
                      </b-col>
                      <b-col md="3">
                        <div class="form-group" v-bind:class="errors.has('relationSecondaryPhone') ? 'has-error':''">
                          <input type="number" class="form-control label-emergencyPhone" data-vv-as="relationSecondaryPhone" name="relationSecondaryPhone" v-model="model.relationSecondaryPhone" placeholder="Phone" />
                          <p v-if="errors.has('relationSecondaryPhone') !== null"></p>
                        </div>
                      </b-col>
                      <b-col md="4">
                        <div class="form-group" v-bind:class="errors.has('relationshipSecondary') ? 'has-error':''">
                          <select v-model="model.relationshipSecondary" :error="errors.first('relationshipSecondary')" name="relationshipSecondary" class="form-control">
                            <option value=null>Please Select Relation</option>
                            <option value="Parent">Parent</option>
                            <option value="Child">Child</option>
                            <option value="Brother">Brother</option>
                            <option value="Sister">Sister</option>
                            <option value="Nephew">Nephew</option>
                            <option value="Niece">Niece</option>
                            <option value="Cousin">Cousin</option>
                          </select>
                        </div>
                      </b-col>
                    </b-row>
                  </b-tab>
                  <b-tab title="Education">
                    <b-row class="mt-1">
                      <b-col md="4">
                        <label class="labels">level of education </label>
                        <div class="form-group" v-bind:class="errors.has('levelEducation1') ? 'has-error':''">
                          <select v-model="education.levelEducation1" :error="errors.first('levelEducation1')" name="levelEducation1" class="form-control">
                            <option value=null>Please Select Level of Education</option>
                            <option value="Doctoral Degree">Doctoral Degree</option>
                            <option value="Master's Degree">Master's Degree</option>
                            <option value="Bachelor's Degree">Bachelor's Degree</option>
                            <option value="Associate Degree">Associate Degree</option>
                            <option value="Senior High School">Senior High School</option>
                          </select>
                        </div>
                      </b-col>
                      <b-col md="4">
                        <label class="labels">name of university / school </label>
                        <div class="form-group" v-bind:class="errors.has('schoolName1') ? 'has-error':''">
                          <input type="text" class="form-control" data-vv-as="schoolName1" name="schoolName1" v-model="education.schoolName1" placeholder="Name of University / School" />
                          <p v-if="errors.has('schoolName1') !== null"></p>
                        </div>
                      </b-col>
                      <b-col md="4">
                        <label class="labels">graduated year </label>
                        <div class="form-group" v-bind:class="errors.has('graduatedYear1') ? 'has-error':''">
                          <input type="number" class="form-control" data-vv-as="graduatedYear1" name="graduatedYear1" v-model="education.graduatedYear1" placeholder="Graduated Year" />
                          <p v-if="errors.has('graduatedYear1') !== null"></p>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="4">
                        <label class="labels">level of education </label>
                        <div class="form-group" v-bind:class="errors.has('levelEducation2') ? 'has-error':''">
                          <select v-model="education.levelEducation2" :error="errors.first('levelEducation2')" name="levelEducation2" class="form-control">
                            <option value=null>Please Select Level of Education</option>
                            <option value="Doctoral Degree">Doctoral Degree</option>
                            <option value="Master's Degree">Master's Degree</option>
                            <option value="Bachelor's Degree">Bachelor's Degree</option>
                            <option value="Associate Degree">Associate Degree</option>
                            <option value="Senior High School">Senior High School</option>
                          </select>
                        </div>
                      </b-col>
                      <b-col md="4">
                        <label class="labels">name of university / school </label>
                        <div class="form-group" v-bind:class="errors.has('schoolName2') ? 'has-error':''">
                          <input type="text" class="form-control" data-vv-as="schoolName2" name="schoolName2" v-model="education.schoolName2" placeholder="Name of University / School" />
                          <p v-if="errors.has('schoolName2') !== null"></p>
                        </div>
                      </b-col>
                      <b-col md="4">
                        <label class="labels">graduated year </label>
                        <div class="form-group" v-bind:class="errors.has('graduatedYear2') ? 'has-error':''">
                          <input type="number" class="form-control" data-vv-as="graduatedYear2" name="graduatedYear2" v-model="education.graduatedYear2" placeholder="Graduated Year" />
                          <p v-if="errors.has('graduatedYear2') !== null"></p>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="4">
                        <label class="labels">level of education </label>
                        <div class="form-group" v-bind:class="errors.has('levelEducation3') ? 'has-error':''">
                          <select v-model="education.levelEducation3" :error="errors.first('levelEducation3')" name="levelEducation3" class="form-control">
                            <option value=null>Please Select Level of Education</option>
                            <option value="Doctoral Degree">Doctoral Degree</option>
                            <option value="Master's Degree">Master's Degree</option>
                            <option value="Bachelor's Degree">Bachelor's Degree</option>
                            <option value="Associate Degree">Associate Degree</option>
                            <option value="Senior High School">Senior High School</option>
                          </select>
                        </div>
                      </b-col>
                      <b-col md="4">
                        <label class="labels">name of university / school </label>
                        <div class="form-group" v-bind:class="errors.has('schoolName3') ? 'has-error':''">
                          <input type="text" class="form-control" data-vv-as="schoolName3" name="schoolName3" v-model="education.schoolName3" placeholder="Name of University / School" />
                          <p v-if="errors.has('schoolName3') !== null"></p>
                        </div>
                      </b-col>
                      <b-col md="4">
                        <label class="labels">graduated year </label>
                        <div class="form-group" v-bind:class="errors.has('graduatedYear3') ? 'has-error':''">
                          <input type="number" class="form-control" data-vv-as="graduatedYear3" name="graduatedYear3" v-model="education.graduatedYear3" placeholder="Graduated Year" />
                          <p v-if="errors.has('graduatedYear3') !== null"></p>
                        </div>
                      </b-col>
                    </b-row>
                  </b-tab>
                  <b-tab title="Employment">
                    <b-row class="mt-1">
                      <b-col md="5">
                        <label class="labels">company *</label>
                        <div class="form-group" v-bind:class="errors.has('company') ? 'has-error':''">
                          <b-form-select name="company" v-model="model.company" v-validate="modelValidations.company" v-bind:class="errors.has('company') ? 'is-invalid':''" :error="errors.first('company')" :options="companyList" placeholder="Company">
                          </b-form-select>
                        </div>
                      </b-col>
                      <b-col md="2">
                      </b-col>
                      <b-col md="4">
                        <label class="labels">employment type *</label>
                        <div class="form-group" v-bind:class="errors.has('employmentType') ? 'has-error':''">
                          <b-form-select name="employmentType" v-model="model.employmentType" v-validate="modelValidations.employmentType" v-bind:class="errors.has('employmentType') ? 'is-invalid':''" :error="errors.first('employmentType')" :options="employmentTypeList">
                          </b-form-select>
                        </div>
                      </b-col>
                      <b-button variant="primary" class="btn-custom" @click="showModalEmploymentType()" style="margin-top:1.9em"><font-awesome-icon icon="plus"/></b-button>
                    </b-row>
                    <b-row>
                      <b-col md="5">
                        <label class="labels">branch *</label>
                        <div class="form-group" v-bind:class="errors.has('branch') ? 'has-error':''">
                          <b-form-select name="branch" v-model="model.branch" v-validate="modelValidations.branch" v-bind:class="errors.has('branch') ? 'is-invalid':''" :error="errors.first('branch')" :options="branchList" placeholder="Branch">
                          </b-form-select>
                        </div>
                      </b-col>
                      <b-col md="2">
                        <label class="labels"></label>
                        <div class="form-group">
                          <b-button variant="light" style="margin-left:-33px!important; margin-top:6px!important; padding-bottom:6px!important;" disabled><font-awesome-icon icon="spinner" spin v-if="isLoadingBranch" />
                          </b-button>
                        </div>
                      </b-col>
                      <b-col md="4">
                        <label class="labels">position *</label>
                        <div class="form-group" v-bind:class="errors.has('position') ? 'has-error':''">
                          <b-form-select name="position" v-model="model.position" v-validate="modelValidations.position" v-bind:class="errors.has('position') ? 'is-invalid':''" :error="errors.first('position')" :options="positionList" placeholder="Position">
                          </b-form-select>
                        </div>
                      </b-col>
                      <b-button variant="primary" class="btn-custom" @click="showModalPosition()" style="margin-top:1.9em"><font-awesome-icon icon="plus"/></b-button>
                    </b-row>
                    <b-row>
                      <b-col md="5">
                        <label class="labels">department *</label>
                        <div class="form-group" v-bind:class="errors.has('department') ? 'has-error':''">
                          <b-form-select name="department" v-model="model.department" v-validate="modelValidations.department" v-bind:class="errors.has('department') ? 'is-invalid':''" :error="errors.first('department')" :options="departmentList" placeholder="Department">
                          </b-form-select>
                        </div>
                      </b-col>
                      <b-col md="2">
                        <label class="labels"></label>
                        <div class="form-group">
                          <b-button variant="light" style="margin-left:-33px!important; margin-top:6px!important; padding-bottom:6px!important;" disabled><font-awesome-icon icon="spinner" spin v-if="isLoadingDepartment" />
                          </b-button>
                        </div>
                      </b-col>
                      <b-col md="4">
                        <label class="labels">start work * </label>
                        <div class="form-group" v-bind:class="errors.has('firstDate') ? 'has-error':''">
                          <b-form-datepicker type="date" :max="max" class="form-control" v-bind:class="errors.has('firstDate') ? 'is-invalid':''" data-vv-as="firstDate" name="firstDate" v-model="model.firstDate" v-validate="'required'" placeholder="Start Work" />
                          <p v-if="errors.has('firstDate') !== null"></p>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="5">
                        <label class="labels">pic name </label>
                        <div class="form-group" v-bind:class="errors.has('picName') ? 'has-error':''">
                          <b-form-select name="picName" v-model="model.picName" v-bind:class="errors.has('picName') ? 'is-invalid':''" :error="errors.first('picName')" :options="dataItem" placeholder="PIC Name">
                          </b-form-select>
                        </div>
                      </b-col>
                      <!-- <b-col md="5">
                        <label class="labels">PIC Name </label>
                        <typeahead3 class="mb-3" ref="technicianTypeahead" :preventAutofocus="false" :labelFields="['firstName', 'lastName']" :placeholder="'PIC Name'" :urlSearch="apiUrl.profile" arr-response="profile" :model="tableFilter.employee" customQueryParamName="search" />
                      </b-col> -->
                      <!-- <b-col md="5">
                        <label class="labels">role *</label>
                        <div class="form-group" v-bind:class="errors.has('role') ? 'has-error':''">
                          <select placeholder="Role" v-model="model.role" v-validate="modelValidations.role" v-bind:class="errors.has('role') ? 'is-invalid':''" :error="errors.first('role')" name="role" class="form-control">
                            <option value="">Please Select Role</option>
                            <option value="Supervisor">Supervisor</option>
                            <option value="Manager">Manager</option>
                            <option value="Admin">Admin</option>
                            <option value="User">User</option>
                            <option value="Transportation">Transportation</option>
                            <option value="Other">Other</option>
                          </select>
                        </div>
                      </b-col> -->
                      <b-col md="2">
                      </b-col>
                      <b-col md="4">
                        <label class="labels">leave quota *</label>
                        <div class="form-group" v-bind:class="errors.has('leaveQuota') ? 'has-error':''">
                          <input type="text" class="form-control" v-bind:class="errors.has('leaveQuota') ? 'is-invalid':''" v-validate="'required'" name="leaveQuota" v-model="model.leaveQuota" placeholder="Leave Quota" />
                          <p v-if="errors.has('leaveQuota') !== null"></p>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <!--<b-col md="2">
                      </b-col>-->
                      <b-col md="12">
                        <label class="labels">job description</label>
                        <div class="form-group" v-bind:class="errors.has('jobDesk') ? 'has-error':''">
                          <b-form-textarea rows="4" type="text" class="form-control" name="jobDesk" v-model="model.jobDesk" placeholder="Job Description" />
                          <p v-if="errors.has('jobDesk') !== null"></p>
                        </div>
                      </b-col>
                    </b-row>
                    <b-button :variant="$route.params.id !== undefined ? 'warning' : 'primary'" class="btn-back float-right" style="margin-top:150px!important;" type="submit"><font-awesome-icon icon="save"></font-awesome-icon> {{$route.params.id !== undefined ? 'Update' : 'Save'}} </b-button>
                  </b-tab>
                  <!--<b-tab title="Documents">
                    <b-row class="mt-1">
                      <b-col md="2 mt-5"><label class="labels">ID Card</label></b-col>
                      <b-row v-if="model.idCardList.length === 0">
                        <b-col md="9 mb-3">
                          <p class="text-secondary text-center border border-radius p-2" style="background-color:#f5f5f5"><b-img :src="'/img/general/Imagexhdpi.png'" class="img-responsive" width="70" height="50"/><br><br><i>No Photo Submitted</i></p>
                        </b-col>
                        <b-col md="3 mt-2">
                          <b-button variant="primary" class="btn-custom" @click="showModalIdCard()" style="margin-top:1.9em"><font-awesome-icon icon="plus"/></b-button>
                        </b-col>
                      </b-row>
                      <viewer :images="model.idCardList" v-else>
                      <b-row>
                        <b-col md="3" v-for="(src, index) in model.idCardList" :key="index">
                          <p class="text-secondary text-center border p-2" v-if="src === null"><i>No Photo Submitted</i></p>
                          <b-img v-else :src="src" class="img-responsive" width="100" height="50"/>
                        </b-col>
                        <b-col md="2">
                          <b-button variant="primary" class="btn-custom" @click="showModalIdCard()" style="margin-top:1.9em"><font-awesome-icon icon="plus"/></b-button>
                        </b-col>
                      </b-row>
                      </viewer>
                    </b-row>
                    <b-row>
                        <b-col md="2 mt-5"><label class="labels">CV / Resume</label></b-col>
                        <b-row v-if="model.cvResumeList.length === 0">
                            <b-col md="9 mb-3">
                                <p class="text-secondary text-center border border-radius p-2" style="background-color:#f5f5f5"><b-img :src="'/img/general/Imagexhdpi.png'" class="img-responsive" width="70" height="50"/><br><br><i>No Photo Submitted</i></p>
                            </b-col>
                            <b-col md="3 mt-2">
                                <b-button variant="primary" class="btn-custom" @click="showModalCvResume()" style="margin-top:1.9em"><font-awesome-icon icon="plus"/></b-button>
                            </b-col>
                        </b-row>
                        <viewer :images="model.cvResumeList" v-else>
                        <b-row>
                            <b-col md="3" v-for="(src, index) in model.cvResumeList" :key="index">
                                <p class="text-secondary text-center border p-2" v-if="src === null"><i>No Photo Submitted</i></p>
                                <b-img v-else :src="src" class="img-responsive" width="100" height="50"/>
                            </b-col>
                            <b-col md="2">
                              <b-button variant="primary" class="btn-custom" @click="showModalCvResume()" style="margin-top:1.9em"><font-awesome-icon icon="plus"/></b-button>
                            </b-col>
                        </b-row>
                        </viewer>
                      </b-row>
                      <b-row>
                        <b-col md="2 mt-5"><label class="labels">Study Certification</label></b-col>
                        <b-row v-if="model.studyCertificationList.length === 0">
                            <b-col md="9 mb-3">
                                <p class="text-secondary text-center border border-radius p-2" style="background-color:#f5f5f5"><b-img :src="'/img/general/Imagexhdpi.png'" class="img-responsive" width="70" height="50"/><br><br><i>No Photo Submitted</i></p>
                            </b-col>
                            <b-col md="3 mt-2">
                                <b-button variant="primary" class="btn-custom" @click="showModalStudyCertification()" style="margin-top:1.9em"><font-awesome-icon icon="plus"/></b-button>
                            </b-col>
                        </b-row>
                        <viewer :images="model.studyCertificationList" v-else>
                        <b-row>
                            <b-col md="3" v-for="(src, index) in model.studyCertificationList" :key="index">
                                <p class="text-secondary text-center border p-2" v-if="src === null"><i>No Photo Submitted</i></p>
                                <b-img v-else :src="src" class="img-responsive" width="100" height="50"/>
                            </b-col>
                            <b-col md="2">
                              <b-button variant="primary" class="btn-custom" @click="showModalStudyCertification()" style="margin-top:1.9em"><font-awesome-icon icon="plus"/></b-button>
                            </b-col>
                        </b-row>
                        </viewer>
                      </b-row>
                      <b-row>
                        <b-col md="2 mt-5"><label class="labels">Insurance</label></b-col>
                        <b-row v-if="model.insuranceList.length === 0">
                            <b-col md="9 mb-3">
                                <p class="text-secondary text-center border border-radius p-2" style="background-color:#f5f5f5"><b-img :src="'/img/general/Imagexhdpi.png'" class="img-responsive" width="70" height="50"/><br><br><i>No Photo Submitted</i></p>
                            </b-col>
                            <b-col md="3 mt-2">
                                <b-button variant="primary" class="btn-custom" @click="showModalInsurance()" style="margin-top:1.9em"><font-awesome-icon icon="plus"/></b-button>
                            </b-col>
                        </b-row>
                        <viewer :images="model.insuranceList" v-else>
                        <b-row>
                            <b-col md="3" v-for="(src, index) in model.insuranceList" :key="index">
                                <p class="text-secondary text-center border p-2" v-if="src === null"><i>No Photo Submitted</i></p>
                                <b-img v-else :src="src" class="img-responsive" width="100" height="50"/>
                            </b-col>
                            <b-col md="2">
                              <b-button variant="primary" class="btn-custom" @click="showModalInsurance()" style="margin-top:1.9em"><font-awesome-icon icon="plus"/></b-button>
                            </b-col>
                        </b-row>
                        </viewer>
                      </b-row>
                      <b-row>
                          <b-col md="2 mt-5"><label class="labels">Others</label></b-col>
                          <b-row v-if="model.othersList.length === 0">
                              <b-col md="9 mb-3">
                                  <p class="text-secondary text-center border border-radius p-2" style="background-color:#f5f5f5"><b-img :src="'/img/general/Imagexhdpi.png'" class="img-responsive" width="70" height="50"/><br><br><i>No Photo Submitted</i></p>
                              </b-col>
                              <b-col md="3 mt-2">
                                  <b-button variant="primary" class="btn-custom" @click="showModalOthers()" style="margin-top:1.9em"><font-awesome-icon icon="plus"/></b-button>
                              </b-col>
                          </b-row>
                          <viewer :images="model.othersList" v-else>
                          <b-row>
                              <b-col md="3" v-for="(src, index) in model.othersList" :key="index">
                                  <p class="text-secondary text-center border p-2" v-if="src === null"><i>No Photo Submitted</i></p>
                                  <b-img v-else :src="src" class="img-responsive" width="100" height="50"/>
                              </b-col>
                              <b-col md="2">
                                <b-button variant="primary" class="btn-custom" @click="showModalOthers()" style="margin-top:1.9em"><font-awesome-icon icon="plus"/></b-button>
                              </b-col>
                          </b-row>
                          </viewer>
                      </b-row>
                  </b-tab>-->
                </b-tabs>
                <hr style="width:97%!important;">
                <b-row>
                  <b-col md="6" v-if="this.$route.params.id === undefined">
                    <b-button v-if="tabIndex === 1 || tabIndex === 2 || tabIndex === 3" variant="outline-primary" class="ml-3 tabPrevious float-left" @click="tabIndex--">Previous</b-button>
                    <b-button v-if="tabIndex === 4" variant="outline-primary" class="tabPrevious float-left" style="margin-left:1px!important;" @click="tabIndex--">Previous</b-button>
                  </b-col>
                  <b-col md="6" v-else>
                    <b-button v-if="tabIndex === 1 || tabIndex === 2" variant="outline-primary" class="ml-3 tabPrevious float-left" @click="tabIndex--">Previous</b-button>
                    <b-button v-if="tabIndex === 3" variant="outline-primary" class="tabPrevious float-left" style="margin-left:1px!important;" @click="tabIndex--">Previous</b-button>
                  </b-col>
                  <b-col md="6" v-if="this.$route.params.id === undefined">
                    <b-button v-if="tabIndex !== 4" variant="outline-primary" class="mr-3 tabNext float-right" @click="tabIndex++">Next</b-button>
                  </b-col>
                  <b-col md="6" v-else>
                    <b-button v-if="tabIndex !== 3" variant="outline-primary" class="mr-3 tabNext float-right" @click="tabIndex++">Next</b-button>
                  </b-col>
                </b-row>
                <!-- <b-row v-else>
                  <b-col md="6">
                    <b-button v-if="tabIndex === 1 || tabIndex === 2 || tabindex === 3" variant="outline-primary" class="ml-3 tabPrevious float-left" @click="tabIndex--">Previous</b-button>
                    <b-button v-if="tabIndex === 4" variant="outline-primary" class="tabPrevious float-left" style="margin-left:1px!important;" @click="tabIndex--">Previous</b-button>
                  </b-col>
                  <b-col md="6">
                    <b-button v-if="tabIndex !== 4" variant="outline-primary" class="mr-3 tabNext float-right" @click="tabIndex++">Next</b-button>
                  </b-col>
                </b-row> -->
                <hr style="width:97%!important;">
                  <!-- <div class="text-muted">Current Tab: {{ tabIndex }}</div> -->
              </div>
              <!--<b-row>
                <b-col md="12 mt-4">
                  <hr>
                </b-col>
              </b-row>-->
              <div class="mt-5">
                <b-button class="ml-3" @click="goBack" variant="secondary"><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button>
              </div>
            </form>

          <b-modal id="bv-modal-employmentType" hide-footer>
            <template v-slot:modal-title>
                <h5 class="text-transform">Employment Type</h5>
            </template>
            <form v-on:submit.prevent="doChangeStatusEmploymentType()">
                <div class="d-block">
                    <label for=""><strong>Name</strong></label>
                    <b-form-input v-model="formData.name" placeholder="Enter Name"></b-form-input><br>
                    <label for=""><strong>Note</strong></label>
                    <b-form-textarea rows="3" v-model="formData.note" placeholder="Enter Note"></b-form-textarea>
                </div>
                <b-button class="mt-4" @click="$bvModal.hide('bv-modal-employmentType')"><font-awesome-icon icon="times"></font-awesome-icon> Cancel</b-button>
                <b-button variant="primary" type="submit" class="mt-4 float-right"><font-awesome-icon icon="save"></font-awesome-icon> Submit</b-button>
            </form>
          </b-modal>
          <b-modal id="bv-modal-position" hide-footer>
              <template v-slot:modal-title>
                  <h5 class="text-transform">Position</h5>
              </template>
              <form v-on:submit.prevent="doChangeStatusPosition()">
                  <div class="d-block">
                      <label for=""><strong>Name</strong></label>
                      <b-form-input v-model="formData.name" placeholder="Enter Name"></b-form-input><br>
                      <label for=""><strong>Note</strong></label>
                      <b-form-textarea rows="3" v-model="formData.note" placeholder="Enter Note"></b-form-textarea>
                  </div>
                  <b-button class="mt-4" @click="$bvModal.hide('bv-modal-position')"><font-awesome-icon icon="times"></font-awesome-icon> Cancel</b-button>
                  <b-button variant="primary" type="submit" class="mt-4 float-right"><font-awesome-icon icon="save"></font-awesome-icon> Submit</b-button>
              </form>
          </b-modal>
          <b-modal ref="my-modal-idCard" centered hide-footer :title="'Add ID Card Photo'">
          <form v-on:submit.prevent="doSubmitIdCard">
            <label><strong>Doc</strong></label>
            <div class="expander">
                <b-form-file :required="true" label="ID Card Photo" v-model="modelIdCard.doc" for-input="idCardGroupFile" :error="errors.first('idCard')">
                </b-form-file>
              </div><br>
              <label for=""><strong>Type</strong></label>
              <b-form-input v-model="modelIdCard.type" readonly placeholder="Enter Type"></b-form-input><br>
              <label for=""><strong>Note</strong></label>
              <b-form-input v-model="modelIdCard.note" placeholder="Enter Note"></b-form-input><br>
              <b-button variant="primary" class="btn-back float-right" type="submit"><font-awesome-icon icon="save"></font-awesome-icon> {{this.model.uuid !== null ? 'Update' : 'Submit'}} </b-button>
              <b-button variant="secondary" class="float-left mr-3" @click="hideModalIdCard"><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button>
              </form>
          </b-modal>
          <b-modal ref="my-modal-cvResume" centered hide-footer :title="'Add CV/Resume Photo'">
          <form v-on:submit.prevent="doSubmitCvResume">
              <label><strong>Doc</strong></label>
              <div class="expander">
                  <b-form-file :required="true" label="CV/Resume Photo" v-model="modelCvResume.doc" for-input="cvResumeGroupFile" :error="errors.first('cvResume')">
                  </b-form-file>
              </div><br>
              <label for=""><strong>Type</strong></label>
              <b-form-input v-model="modelCvResume.type" readonly placeholder="Enter Type"></b-form-input><br>
              <label for=""><strong>Note</strong></label>
              <b-form-input v-model="modelCvResume.note" placeholder="Enter Note"></b-form-input><br>
              <b-button variant="primary" class="btn-back float-right" type="submit"><font-awesome-icon icon="save"></font-awesome-icon> {{this.model.uuid !== null ? 'Update' : 'Submit'}} </b-button>
              <b-button variant="secondary" class="float-left mr-3" @click="hideModalCvResume"><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button>
          </form>
          </b-modal>
          <b-modal ref="my-modal-studyCertification" centered hide-footer :title="'Add Study Certification Photo'">
          <form v-on:submit.prevent="doSubmitStudyCertification">
              <label><strong>Doc</strong></label>
              <div class="expander">
                  <b-form-file :required="true" label="Study Certification Photo" v-model="modelStudyCertification.doc" for-input="studyCertificationGroupFile" :error="errors.first('studyCertification')">
                  </b-form-file>
              </div><br>
              <label for=""><strong>Type</strong></label>
              <b-form-input v-model="modelStudyCertification.type" readonly placeholder="Enter Type"></b-form-input><br>
              <label for=""><strong>Note</strong></label>
              <b-form-input v-model="modelStudyCertification.note" placeholder="Enter Note"></b-form-input><br>
              <b-button variant="primary" class="btn-back float-right" type="submit"><font-awesome-icon icon="save"></font-awesome-icon> {{this.model.uuid !== null ? 'Update' : 'Submit'}} </b-button>
              <b-button variant="secondary" class="float-left mr-3" @click="hideModalStudyCertification"><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button>
          </form>
          </b-modal>
          <b-modal ref="my-modal-insurance" centered hide-footer :title="'Add Insurance Photo'">
          <form v-on:submit.prevent="doSubmitInsurance">
              <label><strong>Doc</strong></label>
              <div class="expander">
                  <b-form-file :required="true" label="Insurance Photo" v-model="modelInsurance.doc" for-input="insuranceGroupFile" :error="errors.first('insurance')">
                  </b-form-file>
              </div><br>
              <label for=""><strong>Type</strong></label>
              <b-form-input v-model="modelInsurance.type" readonly placeholder="Enter Type"></b-form-input><br>
              <label for=""><strong>Note</strong></label>
              <b-form-input v-model="modelInsurance.note" placeholder="Enter Note"></b-form-input><br>
              <b-button variant="primary" class="btn-back float-right" type="submit"><font-awesome-icon icon="save"></font-awesome-icon> {{this.model.uuid !== null ? 'Update' : 'Submit'}} </b-button>
              <b-button variant="secondary" class="float-left mr-3" @click="hideModalInsurance"><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button>
          </form>
          </b-modal>
          <b-modal ref="my-modal-others" centered hide-footer :title="'Add Others Photo'">
          <form v-on:submit.prevent="doSubmitOthers">
              <label><strong>Doc</strong></label>
              <div class="expander">
                  <b-form-file :required="true" label="Others Photo" v-model="modelOthers.doc" for-input="othersGroupFile" :error="errors.first('others')">
                  </b-form-file>
              </div><br>
              <label for=""><strong>Type</strong></label>
              <b-form-input v-model="modelOthers.type" readonly placeholder="Enter Type"></b-form-input><br>
              <label for=""><strong>Note</strong></label>
              <b-form-input v-model="modelOthers.note" placeholder="Enter Note"></b-form-input><br>
              <b-button variant="primary" class="btn-back float-right" type="submit"><font-awesome-icon icon="save"></font-awesome-icon> {{this.model.uuid !== null ? 'Update' : 'Submit'}} </b-button>
              <b-button variant="secondary" class="float-left mr-3" @click="hideModalOthers"><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button>
          </form>
          </b-modal>
        </b-card>
    </div>
</template>

<script>
    import Typeahead3 from '@/components/Typeahead3'
    import 'viewerjs/dist/viewer.css'
    import Viewer from 'v-viewer'
    import Vue from 'vue'
    Vue.use(Viewer)

    export default {
      name: 'department-form',
      components: {
        Typeahead3
      },

      data: function() {
        const now = new Date()
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        const maxDate = new Date(today)
        maxDate.setDate(maxDate.getDate() - 0)

        return {
          isLoading: false,
          isLoadingBranch: false,
          isLoadingDepartment: false,
          tabIndex: 0,
          max: maxDate,
          dataAccount: this.$store.getters['account/accountData'],
          apiUrl: {
            profile: window.AppConfig.apiUrl + 'profile',
            userDocument: window.AppConfig.apiUrl + 'user-document'
          },
          modelIdCard: {
            doc: null,
            type: null,
            note: null,
          },
          modelCvResume: {
            doc: null,
            type: null,
            note: null
          },
          modelStudyCertification: {
            doc: null,
            type: null,
            note: null
          },
          modelInsurance: {
            doc: null,
            type: null,
            note: null
          },
          modelOthers: {
            doc: null,
            type: null,
            note: null
          },
          model: {
              uuid: '',
              name: '',
              fullName: '',
              firstName: '',
              lastName: '',
              nickName: '',
              username: '',
              password: '',
              icNumber: '',
              picName: null,
              drivingLicence: '',
              gender: null,
              dob: '',
              pob: '',
              idStaff: null,
              bloodType: null,
              maritalStatus: null,
              addressCurrent: '',
              address: '',
              phone: '',
              workphone: '',
              extPhoneMY: '+60',
              extPhoneID: '+62',
              email: '',
              workemail: '',
              relationPrimaryName: '',
              relationPrimaryPhone: '',
              relationshipPrimary: null,
              relationSecondaryName: '',
              relationSecondaryPhone: '',
              relationshipSecondary: null,
              employmentType: null,
              position: null,
              firstDate: null,
              jobDesk: '',
              department: null,
              branch: null,
              company: null,
              role: '',
              leaveQuota: '',
              idCard: null,
              cvResume: null,
              studyCertification: null,
              insurance: null,
              others: null,
              idCardList: [],
              cvResumeList: [],
              studyCertificationList: [],
              insuranceList: [],
              othersList: [],
              educations: [],
            },
            modelValidations: {
              gender: {
                required: true
              },
              picName: {
                required: true
              },
              bloodType: {
                required: true
              },
              maritalStatus: {
                required: true
              },
              levelEducation1: {
                required: true
              },
              levelEducation2: {
                required: true
              },
              levelEducation3: {
                required: true
              },
              department: {
                required: true
              },
              company: {
                required: true
              },
              branch: {
                required: true
              },
              employmentType: {
                required: true
              },
              position: {
                required: true
              },
              role: {
                required: true
              },
              relationshipPrimary: {
                required: true
              },
              relationshipSecondary: {
                required: true
              },
              icNumber: {
                required: true
              }
            },
            formData: {
                name: null,
                levelEducation: null,
                schoolName: null,
                graduatedYear: null,
                note: null
            },
            departmentList: [
              {
                value: null,
                text: 'Please Select Department'
              }
            ],
            branchList: [
              {
                value: null,
                text: 'Please Select Branch'
              }
            ],
            companyList: [
              {
                value: null,
                text: 'Please Select Company'
              }
            ],
            employmentTypeList: [
              {
                value: null,
                text: 'Please Select Employment Type'
              },
            ],
            positionList: [
              {
                value: null,
                text: 'Please Select Position'
              },
            ],
            educationList: [],
            education: {
              uuid1: '',
              levelEducation1: null,
              schoolName1: '',
              graduatedYear1: '',
              uuid2: '',
              levelEducation2: null,
              schoolName2: '',
              graduatedYear2: '',
              uuid3: '',
              levelEducation3: null,
              schoolName3: '',
              graduatedYear3: '' 
            },
            dataItem: [
              {
                value: null,
                text: 'Please Select PIC Name'
              }
            ],
            tableFilter: {
              employee_name: this.$route.query.employee_name,
              employee: {
                value: null
              }
            }
          }
        },
        watch: {
          'model.company' (value) {
            this.getBranch(value)
          },
          'model.branch' (value) {
            this.getDepartment(value)
          },
          'model.username'(value) {
            if (this.model.username !== null) {
              this.model.idStaff = this.model.username
            } else {
              this.model.idStaff = null
            }
          }
        },
        mounted () {
            this.initData()
            this.getCompany()
            this.getBranch()
            this.getDepartment()
            this.getPosition()
            this.getEmploymentType()
            this.getEmployeeName()
            this.getEducation()
            this.getRole()
            // this.initCompanyList()
        },
        methods: {
            initData() {
              if (this.$route.params.id !== undefined){
                this.getDetail()
              }
            },
            getDetail () {
                this.isLoading = true
                this.$http.get(this.apiUrl.profile + '/' + this.$route.params.id).then(response => {
                  this.model.fullName = response.data.firstName + ' ' + response.data.lastName
                  this.model.firstName = response.data.firstName
                  this.model.lastName = response.data.lastName
                  this.model.username = response.data.username
                  this.model.idStaff = response.data.username
                  this.model.password = response.data.password
                  this.model.nickName = response.data.nickName
                  this.model.icNumber = response.data.icNumber
                  this.model.gender = response.data.gender
                  this.model.dob = response.data.dob
                  this.model.pob = response.data.pob
                  this.model.bloodType = response.data.bloodType
                  this.model.maritalStatus = response.data.maritalStatus
                  this.model.drivingLicence = response.data.drivingLicence
                  this.model.addressCurrent = response.data.addressCurrent
                  this.model.address = response.data.address
                  this.model.phone = response.data.phone
                  this.model.workphone = response.data.workphone
                  this.model.email = response.data.email
                  this.model.workemail = response.data.workemail
                  this.model.relationPrimaryName = response.data.relationPrimaryName
                  this.model.relationPrimaryPhone = response.data.relationPrimaryPhone
                  this.model.relationshipPrimary = response.data.relationshipPrimary
                  this.model.relationSecondaryName = response.data.relationSecondaryName
                  this.model.relationSecondaryPhone = response.data.relationSecondaryPhone
                  this.model.relationshipSecondary = response.data.relationshipSecondary
                  this.model.department = response.data.department.uuid
                  this.model.company = response.data.company.uuid
                  // this.tableFilter.employee = response.data.parent
                  // this.model.role = response.data.role !== null ? response.data.role : '-'
                  this.model.leaveQuota = response.data.leaveQuota
                  this.model.picName = response.data.parent !== null && response.data.parent !== undefined ? response.data.parent.uuid : ''
                  this.model.branch = response.data.branch.uuid
                  this.model.firstDate = response.data.firstDate
                  this.model.employmentType = response.data.employmentType.uuid
                  this.model.position = response.data.position.uuid
                  this.model.jobDesk = response.data.jobDesk
                  this.model.uuid = response.data.uuid !== null ? response.data.uuid : '-'
                  this.model.account = response.data.account.uuid
                  this.education.uuid1 = response.data.educations !== null ? response.data.educations[0].uuid : '-'
                  this.education.uuid2 = response.data.educations !== null ? response.data.educations[1].uuid : '-'
                  this.education.uuid3 = response.data.educations !== null ? response.data.educations[2].uuid : '-'
                  this.education.levelEducation1 = response.data.educations !== null ? response.data.educations[0].levelEducation : null
                  this.education.levelEducation2 = response.data.educations !== null ? response.data.educations[1].levelEducation : null
                  this.education.levelEducation3 = response.data.educations  !== null ? response.data.educations[2].levelEducation : null
                  this.education.schoolName1 = response.data.educations !== null ? response.data.educations[0].schoolName : null
                  this.education.schoolName2 = response.data.educations !== null ? response.data.educations[1].schoolName : null
                  this.education.schoolName3 = response.data.educations !== null ? response.data.educations[2].schoolName : null
                  this.education.graduatedYear1 = response.data.educations !== null && response.data.educations[0].graduatedYear !== "" ? JSON.parse(response.data.educations[0].graduatedYear) : null
                  this.education.graduatedYear2 = response.data.educations !== null && response.data.educations[1].graduatedYear !== "" ? JSON.parse(response.data.educations[1].graduatedYear) : null
                  this.education.graduatedYear3 = response.data.educations !== null && response.data.educations[2].graduatedYear !== "" ? JSON.parse(response.data.educations[2].graduatedYear) : null
                })
                // .catch(error => {
                //     this.isLoading = false
                //     this.$store.dispatch('notification/error', error)
                // })
            },
            getRole() {
              this.$http.get(window.AppConfig.baseApiUrl + 'api/me').then(response => {
                if (this.$route.params.id !== undefined && this.$route.params.id !== null) {
                  this.model.role = response.data.role
                }
              })
              .catch(error => {
                return Promise.reject(error)
              })
            },
            // getEmployeeName() {
            //   this.$http.get(window.AppConfig.apiUrl + 'profile').then(response => {
            //     response.data._embedded.profile.forEach(data => {
            //       let names = data.firstName + '\xa0' + data.lastName
            //       this.fullName = names
            //       this.dataItem.push({
            //         value: data.uuid,
            //         text: this.fullName
            //       })
            //     })
            //   })
            // },
            getEmployeeName () {
              this.$http.get(window.AppConfig.apiUrl + 'user-access').then(response => {
                response.data._embedded.user_access.forEach(data => {
                  let employeeFirstName = data.userProfile.firstName !== null ? data.userProfile.firstName : ''
                  let employeeLastName = data.userProfile.lastName !== null ? data.userProfile.lastName : ''
                  let names = employeeFirstName + '\xa0' + employeeLastName
                  this.fullName = names
                  this.dataItem.push({
                    value: data.userProfile.uuid,
                    text: this.fullName
                  })
                })
              })
            },
            getCompany () {
              this.$http.get(window.AppConfig.apiUrl + 'company?limit=100').then(response => {
                response.data._embedded.company.forEach(data => {
                    this.companyList.push({
                      value: data.uuid,
                      text: data.name
                    })
                })
              })
            },
            getBranch (companyUuid = null) {
              this.isLoadingBranch = true
              this.$http.get(window.AppConfig.apiUrl + 'branch?limit=100&company_uuid=' + companyUuid + '&is_active=1').then(response => {
                this.branchList = [
                  {
                    value: null,
                    text: 'Please Select Branch'
                  }
                ]
                this.isLoadingBranch = false
                response.data._embedded.branch.forEach(data => {
                    this.branchList.push({
                      value: data.uuid,
                      text: data.name
                    })
                })
              }).catch(error => {
                window.consoleLog(error)
                this.isLoadingBranch = false
              })
            },
            getDepartment (branchUuid = null) {
              this.isLoadingDepartment = true
              this.$http.get(window.AppConfig.apiUrl + 'department?limit=100&branch_uuid=' + branchUuid + '&is_active=1').then(response => {
                this.departmentList = [
                  {
                    value: null,
                    text: 'Please Select Department'
                  }
                ]
                this.isLoadingDepartment = false
                response.data._embedded.department.forEach(data => {
                    this.departmentList.push({
                      value: data.uuid,
                      text: data.name
                    })
                })
              }).catch(error => {
                window.consoleLog(error)
                this.isLoadingDepartment = false
              })
            },
            getEducation () {
              this.$http.get(window.AppConfig.apiUrl + 'education?limit=100&user_uuid=' + this.$route.params.id).then(response => {
                this.educationList = []
                response.data._embedded.education.forEach(data => {
                      this.educationList.push(data)
                    })
                })
            },
            showModalEmploymentType () {
                this.formData.name = null
                this.formData.note = null
                this.$bvModal.show('bv-modal-employmentType')
            },
            doChangeStatusEmploymentType () {
                this.isLoading = true
                let model = {
                    name: this.formData.name,
                    note: this.formData.note
                }
                this.$http.post(window.AppConfig.apiUrl + 'employment-type', model)
                .then(() => {
                    this.isLoading = false
                    this.formData.name = null
                    this.formData.note = null
                    this.$bvModal.hide('bv-modal-employmentType')
                    this.getEmploymentType()
                    this.$store.dispatch('notification/success', 'Employment Type has been added')
                })
                .catch(error => {
                    this.isLoading = true
                    this.$store.dispatch('notification/error', error)
                });
            },
            getEmploymentType () {
              this.$http.get(window.AppConfig.apiUrl + 'employment-type?limit=100').then(response => {
                this.employmentTypeList = [{
                  value: null,
                  text: 'Please Select Employment Type'
                }]
                  response.data._embedded.employment_type.forEach(data => {
                    this.employmentTypeList.push({
                      value: data.uuid,
                      text: data.name
                    })
                  })
              })
            },
            showModalPosition () {
                this.formData.name = null
                this.formData.note = null
                this.$bvModal.show('bv-modal-position')
            },
            doChangeStatusPosition () {
                this.isLoading = true
                let model = {
                    name: this.formData.name,
                    note: this.formData.note
                }
                this.$http.post(window.AppConfig.apiUrl + 'position', model)
                .then(() => {
                    this.isLoading = false
                    this.formData.name = null
                    this.formData.note = null
                    this.$bvModal.hide('bv-modal-position')
                    this.getPosition()
                    this.$store.dispatch('notification/success', 'Position has been added')
                })
                .catch(error => {
                    this.isLoading = true
                    this.$store.dispatch('notification/error', error)
                });
            },
            getPosition () {
              this.$http.get(window.AppConfig.apiUrl + 'position?limit=100').then(response => {
                this.positionList = [{
                  value: null,
                  text: 'Please Select Position'
                }]
                  response.data._embedded.position.forEach(data => {
                    this.positionList.push({
                      value: data.uuid,
                      text: data.name
                    })
                  })
              })
            },
            showModalIdCard() {
              this.modelIdCard.type = 'ID Card'
              this.modelIdCard.note = null
              this.model.uuid = null
              this.$validator.reset();
              this.$refs['my-modal-idCard'].show()
            },
            hideModalIdCard () {
                this.resetData()
                this.$refs['my-modal-idCard'].hide()
            },
            showModalCvResume() {
                this.modelCvResume.type = 'CV / Resume'
                this.modelCvResume.note = null
                this.model.uuid = null
                this.$validator.reset();
                this.$refs['my-modal-cvResume'].show()
            },
            hideModalCvResume () {
                this.resetData()
                this.$refs['my-modal-cvResume'].hide()
            },
            showModalStudyCertification() {
                this.modelStudyCertification.type = 'Study Certification'
                this.modelStudyCertification.note = null
                this.model.uuid = null
                this.$validator.reset();
                this.$refs['my-modal-studyCertification'].show()
            },
            hideModalStudyCertification () {
                this.resetData()
                this.$refs['my-modal-studyCertification'].hide()
            },
            showModalInsurance() {
                this.modelInsurance.type = 'Insurance'
                this.modelInsurance.note = null
                this.model.uuid = null
                this.$validator.reset();
                this.$refs['my-modal-insurance'].show()
            },
            hideModalInsurance () {
                this.resetData()
                this.$refs['my-modal-insurance'].hide()
            },
            showModalOthers() {
                this.modelOthers.type = 'Others'
                this.modelOthers.note = null
                this.model.uuid = null
                this.$validator.reset();
                this.$refs['my-modal-others'].show()
            },
            hideModalOthers () {
                this.resetData()
                this.$refs['my-modal-others'].hide()
            },
            resetData () {
                this.model.idCardPhoto = null
                this.model.cvResumePhoto = null
                this.model.studyCertificationPhoto = null
                this.model.insurancePhoto = null
                this.model.othersPhoto = null
            },
            doSubmitIdCard () {
              this.$validator.validateAll().then(res => {
                if (res) {
                  this.isLoading = true
                  let formData = new FormData()
                  formData.append('user', this.$route.params.uuid)
                    formData.append('doc', this.modelIdCard.doc)
                    if (this.modelIdCard.type !== null) {
                        formData.append('type', this.modelIdCard.type)
                    }
                    if (this.modelIdCard.note !== null) {
                        formData.append('note', this.modelIdCard.note)
                    }
                  this.$http.post(this.apiUrl.userDocument, formData).then(response => {
                    this.isLoading = false
                    this.$store.dispatch('notification/success', 'ID Card Photo/File successfully added.')
                    this.getDetail()
                    this.hideModalIdCard()
                  }).catch(error => {
                    this.isLoading = false
                    this.$store.dispatch('notification/error', error)
                  })
                }
              })
            },
            doSubmitCvResume () {
              this.$validator.validateAll().then(res => {
                if (res) {
                    this.isLoading = true
                    let formData = new FormData()
                    formData.append('user', this.$route.params.uuid)
                    formData.append('doc', this.modelCvResume.doc)
                    if (this.modelCvResume.type !== null) {
                        formData.append('type', this.modelCvResume.type)
                    }
                    if (this.modelCvResume.note !== null) {
                        formData.append('note', this.modelCvResume.note)
                    }
                    this.$http.post(this.apiUrl.userDocument, formData).then(response => {
                      this.isLoading = false
                      this.$store.dispatch('notification/success', 'CV / Resume Photo/File successfully added.')
                      this.getDetail()
                      this.hideModalIdCard()
                    }).catch(error => {
                      this.isLoading = false
                      this.$store.dispatch('notification/error', error)
                    })
                  }
               })
            },
            doSubmitStudyCertification () {
              this.$validator.validateAll().then(res => {
                if (res) {
                    this.isLoading = true
                    let formData = new FormData()
                    formData.append('user', this.$route.params.uuid)
                    formData.append('doc', this.modelStudyCertification.doc)
                    if (this.modelStudyCertification.type !== null) {
                        formData.append('type', this.modelStudyCertification.type)
                    }
                    if (this.modelStudyCertification.note !== null) {
                        formData.append('note', this.modelStudyCertification.note)
                    }
                    this.$http.post(this.apiUrl.userDocument, formData).then(response => {
                      this.isLoading = false
                      this.$store.dispatch('notification/success', 'Study Certification Photo/File successfully added.')
                      this.getDetail()
                      this.hideModalIdCard()
                    }).catch(error => {
                      this.isLoading = false
                      this.$store.dispatch('notification/error', error)
                    })
                  }
               })
            },
            doSubmitInsurance () {
              this.$validator.validateAll().then(res => {
                if (res) {
                    this.isLoading = true
                    let formData = new FormData()
                    formData.append('user', this.$route.params.uuid)
                    formData.append('doc', this.modelInsurance.doc)
                    if (this.modelInsurance.type !== null) {
                        formData.append('type', this.modelInsurance.type)
                    }
                    if (this.modelInsurance.note !== null) {
                        formData.append('note', this.modelInsurance.note)
                    }
                    this.$http.post(this.apiUrl.userDocument, formData).then(response => {
                      this.isLoading = false
                      this.$store.dispatch('notification/success', 'Insurance Photo/File successfully added.')
                      this.getDetail()
                      this.hideModalIdCard()
                    }).catch(error => {
                      this.isLoading = false
                      this.$store.dispatch('notification/error', error)
                    })
                  }
               })
            },
            doSubmitOthers () {
              this.$validator.validateAll().then(res => {
                if (res) {
                    this.isLoading = true
                    let formData = new FormData()
                    formData.append('user', this.$route.params.uuid)
                    formData.append('doc', this.modelOthers.doc)
                    if (this.modelOthers.type !== null) {
                        formData.append('type', this.modelOthers.type)
                    }
                    if (this.modelOthers.note !== null) {
                        formData.append('note', this.modelOthers.note)
                    }
                    this.$http.post(this.apiUrl.userDocument, formData).then(response => {
                      this.isLoading = false
                      this.$store.dispatch('notification/success', 'Others Photo/File successfully added.')
                      this.getDetail()
                      this.hideModalIdCard()
                    }).catch(error => {
                      this.isLoading = false
                      this.$store.dispatch('notification/error', error)
                    })
                  }
               })
            },
            doEdit (row) {
                this.setData(row)
                this.$refs['my-modal-idCard'].show()
            },
            setData (row) {
                this.model.uuid = row.uuid
                this.model.idCard = row.idCard
            },
            onFileIdCardPhoto (event) {
                this.modelIdCard.doc = event.target.files[0]
            },
            clearImageIdCardPhoto () {
                this.$refs.doc.value = ''
                this.modelIdCard.doc = null
            },
            onFileCvResumePhoto (event) {
                this.modelCvResume.doc = event.target.files[0]
            },
            clearImageCvResumePhoto () {
                this.$refs.doc.value = ''
                this.modelCvResume.doc = null
            },
            onFileStudyCertificationPhoto (event) {
                this.modelStudyCertification.doc = event.target.files[0]
            },
            clearImageStudyCertificationPhoto () {
                this.$refs.doc.value = ''
                this.modelStudyCertification.doc = null
            },
            onFileInsurancePhoto (event) {
                this.modelInsurance.doc = event.target.files[0]
            },
            clearImageInsurancePhoto () {
                this.$refs.doc.value = ''
                this.modelInsurance.doc = null
            },
            onFileOthersPhoto (event) {
                this.modelOthers.doc = event.target.files[0]
            },
            clearImageOthersPhoto () {
                this.$refs.doc.value = ''
                this.modelOthers.doc = null
            },
            getDateTime (value) {
                if (value !== null) {
                    return this.$moment(value).format('YYYY-MM-DD HH:mm A')
                } else {
                    return '-'
                }
            },
            goBack () {
                window.goBack(this)
            },
            getStatusColor (val) {
                switch (parseInt(val)) {
                case 0:
                    return 'success'
                    break
                case 1:
                    return 'info'
                    break
                }
            },
            doSubmit () {
              this.$validator.validateAll().then(res => {
                if (res) {
                  this.model.educations = [
                    {
                      "uuid": this.education.uuid1,
                      "levelEducation": this.education.levelEducation1,
                      "schoolName": this.education.schoolName1,
                      "graduatedYear": this.education.graduatedYear1
                    },
                    {
                      "uuid": this.education.uuid2,
                      "levelEducation": this.education.levelEducation2,
                      "schoolName": this.education.schoolName2,
                      "graduatedYear": this.education.graduatedYear2
                    },
                    {
                      "uuid": this.education.uuid3,
                      "levelEducation": this.education.levelEducation3,
                      "schoolName": this.education.schoolName3,
                      "graduatedYear": this.education.graduatedYear3
                    },
                  ]
                  // this.model.idCard = [
                  //   {
                  //     "doc1": this.modelIdCard.doc1,
                  //     "type1": this.modelIdCard.type1,
                  //     "note1": this.modelIdCard.note1
                  //   }
                  // ],
                  // this.model.cvResume = [
                  //   {
                  //     "doc2": this.modelCvResume.doc2,
                  //     "type2": this.modelCvResume.type2,
                  //     "note2": this.modelCvResume.note2
                  //   }
                  // ],
                  // this.model.studyCertification = [
                  //   {
                  //     "doc3": this.modelStudyCertification.doc3,
                  //     "type3": this.modelStudyCertification.type3,
                  //     "note3": this.modelStudyCertification.note3
                  //   }
                  // ],
                  // this.model.insurance = [
                  //   {
                  //     "doc4": this.insurance.doc4,
                  //     "type4": this.insurance.type4,
                  //     "note4": this.insurance.note4
                  //   }
                  // ],
                  // this.model.cvResume = [
                  //   {
                  //     "doc2": this.modelCvResume.doc2,
                  //     "type2": this.modelCvResume.type2,
                  //     "note2": this.modelCvResume.note2
                  //   }
                  // ],
                  let formData = new FormData()
                  formData.append('firstName', this.model.firstName)
                  formData.append('lastName', this.model.lastName)
                  formData.append('nickName', this.model.nickName)
                  if (this.$route.params.id === undefined) {
                    formData.append('username', this.model.username)
                    formData.append('password', this.model.password)
                    formData.append('email', this.model.email)
                  }
                  formData.append('icNumber', this.model.icNumber)
                  formData.append('drivingLicence', this.model.drivingLicence)
                  formData.append('dob', this.model.dob)
                  formData.append('pob', this.model.pob)
                  formData.append('gender', this.model.gender)
                  formData.append('bloodType', this.model.bloodType)
                  formData.append('maritalStatus', this.model.maritalStatus)
                  formData.append('address', this.model.address)
                  if (this.model.phone !== '' && this.model.phone !== undefined && this.model.phone !== 'null' && this.model.phone !== null && this.model.phone.substring(0, 1) === '0') 
                  {
                    formData.append('phone', this.model.phone.replace(/^0+/, ''))
                  } else {
                    formData.append('phone', this.model.phone)
                  }
                  if (this.model.workphone !== '' && this.model.workphone !== undefined && this.model.workphone !== 'null' && this.model.workphone !== null && this.model.workphone.substring(0, 1) == '0') 
                  {
                    formData.append('workphone', this.model.workphone.replace(/^0+/, ''))
                  } else {
                    formData.append('workphone', this.model.workphone)
                  }
                  if (this.model.relationPrimaryPhone !== '' && this.model.relationPrimaryPhone !== undefined && this.model.relationPrimaryPhone !== 'null' && this.model.relationPrimaryPhone !== null && this.model.relationPrimaryPhone.substring(0, 1) == '0') 
                  {
                    formData.append('relationPrimaryPhone', this.model.relationPrimaryPhone.replace(/^0+/, ''))
                  } else {
                    formData.append('relationPrimaryPhone', this.model.relationPrimaryPhone)
                  }
                  if (this.model.relationSecondaryPhone !== '' && this.model.relationSecondaryPhone !== undefined && this.model.relationSecondaryPhone !== 'null' && this.model.relationSecondaryPhone !== null && this.model.relationSecondaryPhone.substring(0, 1) == '0') 
                  {
                    formData.append('relationSecondaryPhone', this.model.relationSecondaryPhone.replace(/^0+/, ''))
                  } else {
                    formData.append('relationSecondaryPhone', this.model.relationSecondaryPhone)
                  }
                  formData.append('workemail', this.model.workemail)
                  formData.append('addressCurrent', this.model.addressCurrent)
                  formData.append('relationPrimaryName', this.model.relationPrimaryName)
                  formData.append('relationshipPrimary', this.model.relationshipPrimary)
                  formData.append('relationSecondaryName', this.model.relationSecondaryName)
                  formData.append('relationshipSecondary', this.model.relationshipSecondary)
                  formData.append('educations', JSON.stringify(this.model.educations))
                  formData.append('department', this.model.department)
                  formData.append('company', this.model.company)
                  formData.append('branch', this.model.branch)
                  // formData.append('role', this.model.role)
                  formData.append('employmentType', this.model.employmentType)
                  formData.append('position', this.model.position)
                  formData.append('firstDate', this.model.firstDate)
                  formData.append('leaveQuota', this.model.leaveQuota)
                  // formData.append('parent', this.tableFilter.employee.value)
                  if (this.model.picName !== null) {
                    formData.append('parent', this.model.picName)
                  }
                  formData.append('jobDesk', this.model.jobDesk)
                  if (this.$route.params.id !== undefined) {
                    this.$http.patch(this.apiUrl.profile + '/' + this.$route.params.id, formData).then(response => {
                      this.$store.dispatch('notification/success', 'Employee has been updated.')
                      window.location.href = document.URL.replace('/edit', '')
                    }).catch(error => {
                      this.$store.dispatch('notification/error', error)
                    })
                  } else {
                    this.$http.post(this.apiUrl.profile, formData).then(response => {
                      this.$store.dispatch('notification/success', 'Employee has been added.')
                        window.location.href = document.URL.replace('/create', '/' + response.data.uuid)
                      }).catch(error => {
                        this.$store.dispatch('notification/error', error)
                      })
                  }
                } else {
                  swal("", "Please fill the required fields!", "info", {
                    buttons: false,
                    timer: 2000
                  });
                }
              })
            },
        }
    }
</script>